// extracted by mini-css-extract-plugin
module.exports = {"slide":"TagManagmentListItem_slide_1r5_H","slide-reverse":"TagManagmentListItem_slide-reverse_2A1ri","editInput":"TagManagmentListItem_editInput_2EzLU"};